import Box from "@mui/material/Box";
import {
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid-pro";

/**
 * The toolbar above the measurements.
 *
 * A component of its own rather than one declared inside the page: a component defined in a
 * render body is a new component type on every render, so the grid would remount the toolbar and
 * the quick filter would lose whatever was being typed into it.
 *
 * Takes no props on purpose. Extra toolbar props need a `ToolbarPropsOverrides` augmentation of
 * `@mui/x-data-grid`, which pnpm does not hoist and TypeScript cannot resolve — and live update
 * is a page setting anyway, so it sits in the filter bar with the period it applies to.
 */
export function MotorDataToolbar() {
  return (
    <GridToolbarContainer sx={{ display: "flex", alignItems: "center", gap: 1, px: 0.5 }}>
      <GridToolbarColumnsButton />
      <Box sx={{ flex: 1 }} />
      <GridToolbarQuickFilter
        debounceMs={150}
        quickFilterParser={input => input.split(" ").filter(Boolean)}
      />
    </GridToolbarContainer>
  );
}
